import React from "react";
import SmartIcon from "./SmartIcon.tsx";

type CheckboxProps = {
  className?: string;
  label?: string;
  value: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  reverse?: boolean;
};

const Checkbox: React.FC<CheckboxProps> = (
  {
    className,
    label,
    value,
    onChange,
    reverse,
  }: CheckboxProps) => (
  <label
    className={`group relative flex items-start select-none cursor-pointer tap-highlight-color ${
      reverse && "flex-row-reverse"
    } ${className}`}
  >
    <input
      className="absolute top-0 left-0 opacity-0 invisible"
      type="checkbox"
      value={value ? 1 : 0}
      onChange={onChange}
      checked={value}
    />
    <span
      className={`relative flex justify-center items-center shrink-0 w-6 h-6 rounded border-2 border-n-300 transition-colors group-hover:border-brandPurple-500 dark:border-n-500 ${
        value ? "bg-brandPurple-500 border-brandPurple-500" : "bg-transparent"
      }`}
    >
            <SmartIcon
              className={`w-4.5 h-4.5 fill-n-100 transition-opacity ${
                value ? "opacity-100" : "opacity-0"
              }`}
              name="check"
            />
        </span>
    {label && (
      <span
        className={`base2 text-n-600 dark:text-n-300 ${
          reverse ? "mr-auto pr-3" : "pl-3"
        }`}
      >
                {label}
            </span>
    )}
  </label>
);

export default Checkbox;
